import { Injectable, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
declare var $: any;

@Injectable()
export class Globals {
  private _UID = "uid";
  private _UOP = "uop";
  private _UROLE = "urole";
  candidateId = 0;
  orgId = 10;
  lang: string = 'en';
  loggedIn: boolean = false;
  menuOpened: boolean = false;
  isAdmin: boolean = false;
  placeholder = "assets/images/placeholder-image.png";
  currentUserInfo: any;
  userOptions: any = [];
  userRoles: any = [];
  sessionExpireTime = 3600000;
  // sessionExpireTime = 60000;


  constructor(public translate: TranslateService, public route: ActivatedRoute, private router: Router, @Inject(DOCUMENT) private document: Document) {
    //this.loadUserInfo();

  }
  loadUserInfo() {
    // this.loggedIn = false;

    if (localStorage.getItem(this.UID) != null) {
      // let UserInfo = JSON.parse(localStorage.getItem(this._UID) ?? '');
      let uid = localStorage.getItem(this.UID) ?? '';
      let UserInfo = JSON.parse(uid);
      // if (UserInfo.logged_in == true) {
      this.currentUserInfo = UserInfo;
      // console.log("login loadUserInfo" + UserInfo.logged_in);
      let uOptions = localStorage.getItem(this.UOP) ?? '';
      if(uOptions)
        this.userOptions = JSON.parse(uOptions);

      let uRoles = localStorage.getItem(this.UROLE) ?? '';
      if(uRoles)
        this.userRoles = JSON.parse(uRoles);

      this.isAdmin = false;
      if (this.userRoles.length > 0) {
        // Admin role id equal (10)
        let adminRole = this.userRoles.filter((role: any) => role.roleid == 10)[0];
        if (adminRole) {
          this.isAdmin = true;
        }
      }
      this.loggedIn = UserInfo.logged_in;
      this.candidateId = this.currentUserInfo.candidateid;
      this.orgId = this.currentUserInfo.orgid;
      // }
    }
  }
  get UID(): string {
    return this._UID;
  }
  get UOP(): string {
    return this._UOP;
  }
  get UROLE(): string {
    return this._UROLE;
  }
  changeLang(targetLang: string) {
    let themeObject = this.document.getElementById('theme');
    if (themeObject != null) {
      this.lang = targetLang
      if (targetLang == "ar") {
        themeObject.setAttribute('href', 'assets/css/theme-rtl.min.css')
        this.document.body.setAttribute('dir', 'rtl');
        // this.document.getElementsByTagName('title')[0].innerHTML = title;
      } else {
        themeObject.setAttribute('href', 'assets/css/theme.min.css');
        this.document.body.setAttribute('dir', 'ltr');
        // this.document.getElementsByTagName('title')[0].innerHTML = title;
      }
    }

  }

  clearSession() {
    localStorage.clear();
    // localStorage.clear();
    this.loggedIn = false;
  }

  checkUserHasPermission(permissionName: string) {
    // console.log(permissionName);
    // console.log(this.userOptions);
    let option = this.userOptions.filter((i: any) => i.author == permissionName)[0];
    if (option != undefined || option != null) {
      return true;
    } else {
      return false;
    }
    //return this.currentUserInfo?.permissions.indexOf(permissionName) === -1 ? false : true;
  }
}